/*
* CM
* 관리 장비 시스템
* 시스템 구성
* 인터페이스 설정
*
* @since 2022-10-21
* @author wj_portal_dev01
* */

import {CmApiPrefix} from '~/utils/restApi'

const
  urlPrefix = `${CmApiPrefix}/interface-set`

export const state = () => ({
  deviceInterfaceList: [] // 인터페이스 리스트
})

export const mutations = {
  setInterfaceList (state, deviceInterfaceList) {
    if (deviceInterfaceList === undefined) {
      state.deviceInterfaceList = []
    } else {
      for (let i = 0; i < deviceInterfaceList.length; i++) {
        if (_.isArray(deviceInterfaceList[i].ipv4address) && deviceInterfaceList[i].ipv4address[0] !== '') { // ''은 툴팁 표시 안함
          deviceInterfaceList[i].ipv4address = deviceInterfaceList[i].ipv4address[0]
        } else {
          deviceInterfaceList[i].ipv4address = null
        }
      }
      state.deviceInterfaceList = deviceInterfaceList
    }
  }
}

export const actions = {
  /* 인터페이스 조회 */
  async getInterfaceList ({commit, state}, param) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/${param}`)
      if (code === 'ok') {
        commit('setInterfaceList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },
  async checkDeviceConnection ({ state }, { ip, port }) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const api = `/api/sm/devices/connect/${ip}/${port}`
      res = await this.$axios.$get(api, {
        loading: true,
        ignoreHaPrefix: true
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}
